export const NEW_COMMENT_ID = 'NEW_COMMENT';